<script setup>
import Button from '../global/Button.vue'
</script>

<template>
	<section class="relative isolate mt-20 bg-white pt-12 lg:py-16">
		<div class="container">
			<div class="grid grid-cols-12 gap-6">
				<div class="col-span-12 flex flex-col items-center justify-center gap-6 text-center lg:col-span-6 lg:items-start lg:gap-12 lg:pr-20 lg:text-left">
					<div class="rounded-lg bg-gradient-to-br from-lavendar-100 via-ruby-100 to-coral-100 p-4">
						<img class="h-12 lg:h-20" src="https://d1f3y6u6f3nh06.cloudfront.net/images/logos/logitechadaptive.svg" alt="" />
					</div>
					<p class="leading-relaxed md:text-xl">A collaboration between Logitech G, AbleGamers, Adaptive Action Sports, and Mount Sinai creating tournaments and a community for gamers who adapt to play.</p>
					<Button href="https://docs.google.com/forms/d/1jPCVRXX15kLNOu9910QXpjmMF0mgVM8PylAWHbEVLfg/viewform?edit_requested=true">Apply Now</Button>
				</div>
				<div class="col-span-12 lg:col-span-6">
					<div class="relative aspect-video w-full overflow-hidden rounded-2xl">
                        					<iframe
						class="absolute left-0 top-0 h-full w-full"
						width="100%"
						height="100%"
						src="https://www.youtube.com/embed/tqHrLE1o_jk"
						frameborder="0"
						allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</div>
		<img class="absolute left-0 top-0 -z-10 h-full w-full object-cover" src="https://d1f3y6u6f3nh06.cloudfront.net/images/backgrounds/hero.jpg" alt="Rocket League Cars" />
	</section>
</template>
